import { render, staticRenderFns } from "./UgcUpload.vue?vue&type=template&id=06f2af6e&scoped=true&"
import script from "./UgcUpload.vue?vue&type=script&lang=js&"
export * from "./UgcUpload.vue?vue&type=script&lang=js&"
import style0 from "./UgcUpload.vue?vue&type=style&index=0&id=06f2af6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2af6e",
  null
  
)

export default component.exports